var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const initParallax = /* @__PURE__ */ __name(($el) => {
  window._stores.scrollProgress.registerSection($el.closest(`.shopify-section`));
  const calculateParallax = /* @__PURE__ */ __name((progress = 0, breakpoints, type = "") => {
    const points = breakpoints.split(",").map((pair) => {
      const [p, v] = pair.trim().split(":").map(Number);
      return { progress: p, value: v };
    }).sort((a, b) => a.progress - b.progress);
    let start = points[0], end = points[points.length - 1];
    for (let i = 0; i < points.length - 1; i++) {
      if (progress >= points[i].progress && progress <= points[i + 1].progress) {
        start = points[i];
        end = points[i + 1];
        break;
      }
    }
    const range = end.progress - start.progress;
    const factor = range === 0 ? 0 : (progress - start.progress) / range;
    const interpolated = start.value + (end.value - start.value) * factor;
    if (type === "rotate") {
      return Math.round(interpolated * 1e3) / 1e3;
    }
    return Math.round(interpolated * 1e3) / 1e3;
  }, "calculateParallax");
  return { calculateParallax };
}, "initParallax");
window._sections["initParallax"] = initParallax;
